import { render } from "./IndicatorSearchTags.vue?vue&type=template&id=51c7c7a3&scoped=true"
import script from "./IndicatorSearchTags.vue?vue&type=script&lang=js"
export * from "./IndicatorSearchTags.vue?vue&type=script&lang=js"

import "./IndicatorSearchTags.vue?vue&type=style&index=0&id=51c7c7a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c7c7a3"]])

export default __exports__